import { Controller } from "@hotwired/stimulus"
import { mount, unmount } from "svelte"
import { SurveyBuilder } from "../survey_builder/survey_builder.svelte.js"
import SurveyQuestions from "../survey_builder/SurveyQuestions.svelte"
import SurveyPreview from "../survey_builder/SurveyPreview.svelte"

// Mounts the survey builder (KODIF-4488, app/javascript/survey_builder): the questions editor, and beside it the live
// preview (chat, the survey page and its email). Its questions are posted as the form's nested question fields.
export default class extends Controller {
  static targets = ["questions", "preview"]
  static values = {
    questions: Array, removedIds: Array, operators: Object, fieldPrefix: String, chatPreviewUrl: String,
    pagePreviewUrl: String, emailPreviewUrl: String
  }

  connect() {
    const builder = new SurveyBuilder({
      questions: this.questionsValue, removedIds: this.removedIdsValue, operators: this.operatorsValue
    })
    this.components = [
      mount(SurveyQuestions, { target: this.questionsTarget, props: { builder, fieldPrefix: this.fieldPrefixValue } })
    ]
    if (this.hasPreviewTarget) {
      this.components.push(mount(SurveyPreview, {
        target: this.previewTarget,
        props: {
          builder, fieldPrefix: this.fieldPrefixValue, chatUrl: this.chatPreviewUrlValue || null,
          pageUrl: this.pagePreviewUrlValue || null,
          emailUrl: this.emailPreviewUrlValue || null
        }
      }))
    }
  }

  disconnect() {
    this.components?.forEach((component) => unmount(component))
    this.components = []
  }
}
